import 'jquery/dist/jquery';
import 'popper.js/dist/umd/popper';
import 'bootstrap/dist/js/bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import './index.css';
import Landing from './components/Landing';
import "./style.css"
const App = () => {
  return ( 
    <Landing />
  );
}

export default App;
